import React from 'react'
import compose from 'recompose/compose'
import { inject, observer } from 'mobx-react'
import { FormattedMessage } from 'react-intl'
import './styles.css'
import LazyLoad from 'react-lazyload'
import { Tag } from 'antd'
import withClientId from '~/App/hocs/withClientId'

// const clientId = process.env.REACT_APP_CLIENT_ID

export default compose(
  inject('i18n'),
  observer,
  withClientId
)((props) => {
  const {
    slug,
    legacy,
    website,
    thumbnailUrl,
    whiteLabelUrl,
    isRegOpen,
    history,
    isBeforeEndPeriods,
    clientId
  } = props

  const handleRedirection = () => {
    if (legacy && website) {
      window.open(website, '_blank').focus()
    } else if (!whiteLabelUrl || clientId) {
      window.scrollTo(0, 0)
      history.push(`/${slug}`)
    } else {
      window.open(whiteLabelUrl, '_blank').focus()
    }
  }
  const regTag = () => {
    if (isRegOpen) {
      return <Tag color="green">
        <FormattedMessage id="app.enabledRegister" defaultMessag="Register" />
      </Tag>
    } else {
      if (isBeforeEndPeriods) {
        return <Tag className="notOpenReg">
          <FormattedMessage id='app.regUpcoming2' />
        </Tag>
      } else {
        return <Tag color="gray">
          <FormattedMessage id='app.regClosed2' />
        </Tag>
      }
    }
  }
  return (
    <div className="eventCardBox" onClick={handleRedirection}>
      <div className="eventCard">
        <div className="eventCardImgWrapper">
          <LazyLoad height={200}>
            <img className="eventCardImg" src={thumbnailUrl} alt="" />
          </LazyLoad>
        </div>
        <div className="eventRegStatusTags">
          {(!whiteLabelUrl || clientId)
            ? regTag()
            : <Tag color="#f50">
              <FormattedMessage id="app.enabledRegister" defaultMessag="Register" />
            </Tag>
          }
          {website &&
            <Tag color="#2db7f5">
              Website
            </Tag>}
        </div>
      </div>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/App/EventListPage/EventItem/FinishedEventItem.js